import { useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";

import { Authorization, useAuthorization } from "../../common/AuthorizationCpt";
import { PaymentHeader } from "../Payment/PaymentStyles";
import { TurnCreationResource } from "./TurnCreation/TurnCreationResource";
import { TurnTrackingResource } from "./TurnTracking/TurnTrackingResource";

const BILLING_TURN_OPTIONS = {
  turns: {
    screenName: "RELACIÓN DE VOLANTES FACTURADOS",
    path: "/web/importaciones/facturacion/citas",
    authorization: [
      "quotation.get_quotation_quoted",
      "quotation.get_quotation_pending",
      "quotation.get_quotation_paid",
    ],
    children: {
      create: {
        screenName: "Creación de Citas",
        path: "/web/importaciones/facturacion/citas/creacion",
        authorization: ["volante.get_volante_appointment"],
        component: function Create() {
          return <TurnCreationResource />;
        },
      },
      track: {
        screenName: "Seguimiento de Citas",
        path: "/web/importaciones/facturacion/citas/seguimiento",
        authorization: ["appointment.get_appointments"],
        component: function Track() {
          return <TurnTrackingResource />;
        },
      },
    },
  },
};

function VctScreen() {
  const authorization = useAuthorization();

  const [options] = useState(() => {
    const options = Object.keys(BILLING_TURN_OPTIONS.turns.children)
      .map((key) => BILLING_TURN_OPTIONS.turns.children[key])
      .filter((option) => {
        return authorization.isAllowedByActions(option.authorization);
      });
    return options;
  });

  const history = useHistory();
  useEffect(() => {
    if (history.location.pathname === BILLING_TURN_OPTIONS.turns.path) {
      const first = options[0];
      if (first) {
        history.push(first.path);
      } else {
        history.push("/web");
      }
    }
  }, [history, options, history.location.pathname]);

  const [quotationType, updateQuotationType] = useState<any>();

  useEffect(() => {
    const getQuotationType = (pathname) => {
      const { create, track } = BILLING_TURN_OPTIONS.turns.children;

      if (pathname.startsWith(create.path)) return 0;
      if (pathname.startsWith(track.path)) return 1;
    };

    const unsub = history.listen((location) => {
      const pathname = location.pathname;
      const quotationType = getQuotationType(pathname);
      updateQuotationType(quotationType);
    });

    const pathname = history.location.pathname;
    const quotationType = getQuotationType(pathname);
    updateQuotationType(quotationType);

    return () => {
      unsub();
    };
  }, [history]);

  return (
    <div>
      <PaymentHeader>
        <h2>RELACIÓN DE VOLANTES FACTURADOS</h2>
        <div className="payment-tabs">
          {options.map((option, i) => {
            return (
              <Authorization key={i} actions={option.authorization}>
                <div
                  className="quotations tab-name"
                  onClick={() => {
                    history.push(option.path);
                  }}
                  style={{
                    borderBottomStyle: i === quotationType ? "solid" : "none",
                    borderColor: "#0e1944",
                  }}
                >
                  {option.screenName}
                </div>
              </Authorization>
            );
          })}
        </div>
      </PaymentHeader>
      {options.map((option, i) => {
        return (
          <Route key={i} path={option.path}>
            <Authorization actions={option.authorization}>
              {option.component()}
            </Authorization>
          </Route>
        );
      })}
    </div>
  );
}

export default VctScreen;
